// extracted by mini-css-extract-plugin
export default {"title":"headline_title__FNhVG"};